export default __webpack_public_path__ + "static/media/sites-pg-mob.49827eb5.svg";